import * as network from './network';
import { invokeWS } from './fabric';
import { router } from '../router/Router';

export const LOGIN_SUCCESS = 'OK';

export async function authenticate(params) {
    const res = invokeWS('authenticate', params, network.POST_REQUEST);
    return res;
}

export async function logout() {
    try {
        await invokeWS('logout', {}, network.POST_REQUEST);
        location.href = `${location.origin}/${router.appPrefix ? `${router.appPrefix}/` : ''}`;
    } catch (error) {
        console.error(error);
    }
}